jQuery(function ($) {
  if ($(".308-result-emb-table").length <= 0) {
    return;
  }

  $(".emb-action-delete").on("click", function (e) {
    const elm = $(this);
    const idx = elm.data("emb-index");

    $("#emb-actions-" + idx).hide();
    $("#emb-deletion-" + idx).show();
  });

  $(".emb-deletion-cancel").on("click", function (e) {
    const elm = $(this);
    const idx = elm.data("emb-index");

    $("#emb-actions-" + idx).show();
    $("#emb-deletion-" + idx).hide();
  });

  $(".emb-deletion-delete").on("click", function () {
    const elm = $(this);
    const idx = elm.data("emb-index");
    const nid = elm.data("emb-nid");

    $("#fake-loading").fadeIn();

    const csrfTokenEndpoint = "/session/token";

    $.ajax({
      url: csrfTokenEndpoint,
      type: "GET",
      headers: {
        "Content-Type": "text/plain",
      },
      success: function (token) {
        console.log("token", token);

        $.ajax({
          url: "/node/" + nid,
          type: "DELETE",
          headers: {
            "Content-Type": "application/json",
            'X-CSRF-Token': token,
          },
          success: function (data) {
            console.log("Node deleted successfully.");
            $("#emb-row-" + nid).remove();
            $("#fake-loading").fadeOut();
          },
          error: function (error) {
            console.error("Error deleting the node: " + JSON.stringify(error));
            $("#emb-deletion-" + idx).html('<div class="text-red-500 text-center">Error deleting node: ' + nid + '</div>');
            $("#fake-loading").fadeOut();
          },
        });
      },
      error: function (error) {
        // Handle errors when obtaining the CSRF token.
        console.error("Error obtaining CSRF token: " + JSON.stringify(error));
        $("#emb-deletion-" + idx).html('<div class="text-red-500 text-center">Error obtaining CSRF token.</div>');
        $("#fake-loading").fadeOut();
      },
    });
  });
});
